<template>
    <div>
        <el-form class="sentence-form" ref="form" label-width="80px">
            <!-- data -->
            <div class="data">
                <div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
                    <el-button type="info" plain @click="showSearchBox = true">从翻译中选取</el-button>
                </div>
                <div>
                    <!-- show data -->
                    <div v-for="(item, key) in data.translation.translations" :key="key">
                        <el-form-item :label="item.lang" style="margin-bottom:12px;">
                            <el-input type="textarea" :autosize="{minRows:1}" resize="none" :value="item.text"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <!-- attributes -->
            <el-tabs type="border-card">
                <el-tab-pane>
                    <span slot="label"><i class="el-icon-suitcase-1"></i> 属性</span>
                    <div class="attribute" v-for="(component, index) in attributes" :key="index">
                        <component :is="component.type" v-model="attributes[index]"></component>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div class="actions">
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </el-form>
        <el-dialog title="翻译查询" :visible.sync="showSearchBox" append-to-body>
            <div>
                <TranslationSearch @closeSearchBox="closeSearchBox" v-model="data"></TranslationSearch>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import TranslationSearch from './TranslationSearch.vue'
import elementMixin from '../mixins/graphic/element'
export default {
    name: 'Tag',
    mixins: [elementMixin],
    components: {
        Tags: require('./attribute/Tags.vue').default,
        TranslationSearch,
    },
    data() {
        return {
            showSearchBox: false,
            default: {
                translation: {
                    id: null,
                    translations: [],
                }
            },
            data: {
                translation: {
                    id: null,
                    translations: [],
                }
            },
        }
    },
    methods: {
        emptyData() {
            return this.data.translation.id == null;
        },
        closeSearchBox() {
            this.showSearchBox = false
        },
    },
}
</script>
<style lang="scss">
.attribute {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
        border-bottom: 0px;
    }

    .checkbox {
        margin-top: -12px;
    }
}
</style>